// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* side header css */

.side-menu-navbar .navbar {
    height: 100vh;
    align-items: start;
    justify-content: center;
    padding-top: 15px;
}

.side-menu-navbar .navbar-nav a img {
    width: 24px;
    height: 24px;
}

.side-menu-navbar .navbar-nav li a {
    font-size: 19px;
    color: white;
    margin-bottom: 10px;
}

.side-menu-navbar .navbar-nav li {
    margin-bottom: 5px;
}

.side-menu-navbar .navbar-nav li a span {
    display: block;
    margin-top: 5px;
}

.side-bar-menu {
    width: 5s0px;
    position: fixed;
    height: 100%;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);
    left: 0;
    top: 57px;
    z-index: 9;
}

.nav-link {
    position: relative;
}

.nav-link span {
    opacity: 0;
    transition: 0.3s all ease-in-out;
    padding: 5px;
    background-color: #000;
    color: #fff;
    font-size: 14px;
    position: absolute;
    font-size: 14px;
    position: absolute;
    right: -75px;
    top: 0px;
    z-index: 99;
    width: 65px;
}

.nav-link span::after {
    content: "";
    position: absolute;
    top: 8px;
    left: 0;
    margin-left: -15px;
    border-width: 8px;
    border-style: solid;
    border-color: transparent #000 transparent transparent;
}

.nav-link:hover span {
    opacity: 1;
}

.icon :hover {
    fill: #6655ee;
}

svg {
    width: 22px;
    height: 22px;
}

.fa-plus {
    font-size: 23px;
    color: white;
    display: none;
    position: absolute;
    top: 18px;
}

.fa-user-circle {
    font-size: 20px;
    color: white;
    display: none;
    position: absolute;
    top: 18px;
}

@media(max-width: 991px) {
    .nav-link span {
        display: none!important;
    }
    .navbar.bg-white {
        height: auto!important;
        padding: 5px 0px;
    }
    .navbar-nav.text-center {
        width: 100%;
        display: block!important;
        position: relative;
        bottom: 13px;
        /* left: 22px; */
    }
    .side-menu-navbar .navbar-nav li {
        display: inline-block;
        width: 20%;
    }
    svg {
        width: 24px!important;
        height: 24px!important;
    }
    .side-bar-menu {
        width: 100%!important;
        height: auto!important;
        top: auto!important;
        bottom: 0!important;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
    }
    .fa-plus {
        font-size: 23px;
        color: white;
        display: block;
        position: absolute;
        top: 18px;
        left: 0;
        right: 0;
        margin: 0 auto;
    }
    .fa-home {
        font-size: 23px;
        color: white;
        display: block;
        position: absolute;
        top: 18px;
        left: 0;
        right: 0;
        margin: 0 auto;
    }
    .fa-user {
        font-size: 23px;
        color: white;
        display: block;
        position: absolute;
        top: 18px;
        left: 0;
        right: 0;
        margin: 0 auto;
    }
    .fa-fire {
        font-size: 23px;
        color: white;
        display: block;
        position: absolute;
        top: 18px;
        left: 0;
        right: 0;
        margin: 0 auto;
    }
    .fa-th {
        font-size: 23px;
        color: white;
        display: block;
        position: absolute;
        top: 18px;
        left: 0;
        right: 0;
        margin: 0 auto;
    }
    .fa-user-circle {
        font-size: 23px;
        color: white;
        display: block;
        position: absolute;
        top: 18px;
        left: 0;
        right: 0;
        margin: 0 auto;
    }
}

.profilePic {
    width: 27px;
    height: 27px;
    border-radius: 50%;
}


/* side header css end */
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/sideMenu/sideMenu.component.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,8CAA8C;IAC9C,OAAO;IACP,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gCAAgC;IAChC,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,wBAAwB;QACxB,kBAAkB;QAClB,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,qBAAqB;QACrB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,sBAAsB;IAC1B;IACA;QACI,qBAAqB;QACrB,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;QACnB,8CAA8C;IAClD;IACA;QACI,eAAe;QACf,YAAY;QACZ,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,QAAQ;QACR,cAAc;IAClB;IACA;QACI,eAAe;QACf,YAAY;QACZ,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,QAAQ;QACR,cAAc;IAClB;IACA;QACI,eAAe;QACf,YAAY;QACZ,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,QAAQ;QACR,cAAc;IAClB;IACA;QACI,eAAe;QACf,YAAY;QACZ,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,QAAQ;QACR,cAAc;IAClB;IACA;QACI,eAAe;QACf,YAAY;QACZ,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,QAAQ;QACR,cAAc;IAClB;IACA;QACI,eAAe;QACf,YAAY;QACZ,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,QAAQ;QACR,cAAc;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;;AAGA,wBAAwB","sourcesContent":["/* side header css */\n\n.side-menu-navbar .navbar {\n    height: 100vh;\n    align-items: start;\n    justify-content: center;\n    padding-top: 15px;\n}\n\n.side-menu-navbar .navbar-nav a img {\n    width: 24px;\n    height: 24px;\n}\n\n.side-menu-navbar .navbar-nav li a {\n    font-size: 19px;\n    color: white;\n    margin-bottom: 10px;\n}\n\n.side-menu-navbar .navbar-nav li {\n    margin-bottom: 5px;\n}\n\n.side-menu-navbar .navbar-nav li a span {\n    display: block;\n    margin-top: 5px;\n}\n\n.side-bar-menu {\n    width: 5s0px;\n    position: fixed;\n    height: 100%;\n    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.5);\n    left: 0;\n    top: 57px;\n    z-index: 9;\n}\n\n.nav-link {\n    position: relative;\n}\n\n.nav-link span {\n    opacity: 0;\n    transition: 0.3s all ease-in-out;\n    padding: 5px;\n    background-color: #000;\n    color: #fff;\n    font-size: 14px;\n    position: absolute;\n    font-size: 14px;\n    position: absolute;\n    right: -75px;\n    top: 0px;\n    z-index: 99;\n    width: 65px;\n}\n\n.nav-link span::after {\n    content: \"\";\n    position: absolute;\n    top: 8px;\n    left: 0;\n    margin-left: -15px;\n    border-width: 8px;\n    border-style: solid;\n    border-color: transparent #000 transparent transparent;\n}\n\n.nav-link:hover span {\n    opacity: 1;\n}\n\n.icon :hover {\n    fill: #6655ee;\n}\n\nsvg {\n    width: 22px;\n    height: 22px;\n}\n\n.fa-plus {\n    font-size: 23px;\n    color: white;\n    display: none;\n    position: absolute;\n    top: 18px;\n}\n\n.fa-user-circle {\n    font-size: 20px;\n    color: white;\n    display: none;\n    position: absolute;\n    top: 18px;\n}\n\n@media(max-width: 991px) {\n    .nav-link span {\n        display: none!important;\n    }\n    .navbar.bg-white {\n        height: auto!important;\n        padding: 5px 0px;\n    }\n    .navbar-nav.text-center {\n        width: 100%;\n        display: block!important;\n        position: relative;\n        bottom: 13px;\n        /* left: 22px; */\n    }\n    .side-menu-navbar .navbar-nav li {\n        display: inline-block;\n        width: 20%;\n    }\n    svg {\n        width: 24px!important;\n        height: 24px!important;\n    }\n    .side-bar-menu {\n        width: 100%!important;\n        height: auto!important;\n        top: auto!important;\n        bottom: 0!important;\n        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);\n    }\n    .fa-plus {\n        font-size: 23px;\n        color: white;\n        display: block;\n        position: absolute;\n        top: 18px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n    }\n    .fa-home {\n        font-size: 23px;\n        color: white;\n        display: block;\n        position: absolute;\n        top: 18px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n    }\n    .fa-user {\n        font-size: 23px;\n        color: white;\n        display: block;\n        position: absolute;\n        top: 18px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n    }\n    .fa-fire {\n        font-size: 23px;\n        color: white;\n        display: block;\n        position: absolute;\n        top: 18px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n    }\n    .fa-th {\n        font-size: 23px;\n        color: white;\n        display: block;\n        position: absolute;\n        top: 18px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n    }\n    .fa-user-circle {\n        font-size: 23px;\n        color: white;\n        display: block;\n        position: absolute;\n        top: 18px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n    }\n}\n\n.profilePic {\n    width: 27px;\n    height: 27px;\n    border-radius: 50%;\n}\n\n\n/* side header css end */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
